import React, { VFC } from 'react';
import { browserName } from 'react-device-detect';

import Container from '../../components/Container';
import ModalWalletDetail from '../../components/ModalWalletDetail';
import ModalChooseCoin from '../../components/ModalChooseCoin';
import ModalNetwork from '../../components/ModalNetwork';
import {
  Forbidden,
  Title,
  Tutorial,
  Converter,
  NavBar,
} from '../../components';
import { FORBIDDEN } from '../../constants';
import Header from '../../components/Bridge/Header/header';

const Bridge: VFC = () => {
  if (`${browserName}` !== `Chrome`) {
    return (
      <Container>
        <div className="columns">
          <div className="form-container">
            <Forbidden content={FORBIDDEN.WEB_CONTENT} />
          </div>
        </div>
      </Container>
    );
  }

  return (
    <>
      <Header />
      <NavBar />
      <Container>
        <Title />
        <div className="columns">
          <Tutorial />
          <Converter />
        </div>
      </Container>
      <ModalWalletDetail />
      <ModalChooseCoin />
      <ModalNetwork />
    </>
  );
};

export default Bridge;
